export default __webpack_public_path__ + "static/media/mastercard-colored.6da752e0.svg";